import constants from '#packages/constants';

const { TERM_OF_USE, PRIVACY } = constants.OVERRIDDEN.EXTERNAL_LINKS;

export const externalOverrides = {
  [TERM_OF_USE.KEY]: { [TERM_OF_USE.LINK]: 'about/terms-of-use' },
  [PRIVACY.KEY]: { [PRIVACY.LINK]: 'about/privacy' },
};
